export default {
  SET_EXTRA_FACILITIES: function (state, payload) {
    state.extraFacilities = payload;
  }
}
